import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const AboutPage = () => (
  <>
    <Helmet><title>About Us — Skinnthrive</title></Helmet>

    {/* Hero */}
    <div
      className="py-12 md:py-16 px-4 text-center"
      style={{ background: 'linear-gradient(135deg, #F5F3FF 0%, #FAE8FF 100%)', borderBottom: '1px solid #E5E7EB' }}
    >
      <h1 className="text-3xl md:text-4xl font-bold text-ink mb-4 tracking-tight">Welcome to Skinnthrive</h1>
      <p className="text-ink-soft text-base md:text-lg max-w-2xl mx-auto leading-relaxed">
        Your ultimate destination for premium skincare products tailored to your unique needs.
      </p>
    </div>

    <div className="max-w-4xl mx-auto px-4 py-12 space-y-10">

      {/* Who we are */}
      <div className="bg-white rounded-2xl border border-border p-7">
        <h2 className="text-xl font-bold text-ink mb-3">Who We Are</h2>
        <p className="text-ink-soft text-sm leading-relaxed">
          Our mission is to make advanced skincare accessible to everyone — helping you achieve healthy, radiant skin you
          can truly thrive in.
        </p>
      </div>

      {/* Value pillars */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {[
          { icon: '🧬', title: 'Science-Backed', desc: 'Every product in our catalog is dermatologist-approved and clinically validated for real, visible results.' },
          { icon: '✨', title: 'Curated Collection', desc: 'Cleansers, serums, moisturizers, and targeted treatments for acne, ageing, pigmentation, and dryness.' },
          { icon: '🚚', title: 'Seamless Experience', desc: "From personalized consultations to fast, reliable delivery — we're with you at every step." },
        ].map(v => (
          <div key={v.title} className="text-center p-6 bg-white rounded-2xl border border-border">
            <div className="text-4xl mb-3">{v.icon}</div>
            <h3 className="font-bold text-ink mb-2">{v.title}</h3>
            <p className="text-sm text-ink-soft leading-relaxed">{v.desc}</p>
          </div>
        ))}
      </div>

      {/* At Skinnthrive */}
      <div className="bg-white rounded-2xl border border-border p-7">
        <h2 className="text-xl font-bold text-ink mb-3">At Skinnthrive</h2>
        <p className="text-ink-soft text-sm leading-relaxed">
          We believe that skincare is not just about beauty — it's about self-care, confidence, and embracing your best
          self. Our curated collection features a wide range of products including cleansers, serums, moisturizers, and
          treatments designed to address various skin concerns such as acne, ageing, pigmentation, and dryness.
        </p>
      </div>

      {/* What sets us apart */}
      <div className="bg-white rounded-2xl border border-border p-7">
        <h2 className="text-xl font-bold text-ink mb-3">What Sets Us Apart</h2>
        <p className="text-ink-soft text-sm leading-relaxed mb-3">
          Our dedication to customer satisfaction. From personalized skincare consultations to expert advice and seamless
          shopping experiences, we strive to empower you with the knowledge and products you need to achieve your
          skincare goals.
        </p>
        <p className="text-ink-soft text-sm leading-relaxed">
          Your skin's health and happiness are at the heart of everything we do. Whether you're starting your skincare
          journey or looking to enhance your routine, we're here to guide and support you every step of the way.
        </p>
      </div>

      {/* CTA */}
      <div className="bg-primary text-white rounded-2xl p-8 text-center">
        <h2 className="text-xl font-bold mb-3">Ready to start your skin journey?</h2>
        <p className="text-white/80 text-sm mb-5">
          Shop from our curated range of dermatologist-approved skincare products.
        </p>
        <Link to="/shop" className="inline-block bg-white text-primary font-bold px-8 py-3 rounded-xl hover:bg-gray-100 transition-colors">
          Shop Now
        </Link>
      </div>

    </div>
  </>
);

export default AboutPage;
